// extracted by mini-css-extract-plugin
export default {"restrictedRow":"_application-queue_restrictedRow__csEmN","statusCell":"_application-queue_statusCell__cotYT","queueDialogMessage":"_application-queue_queueDialogMessage__AILQh"};